"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.brandsPrimaryColor = exports.brands = void 0;
exports.brands = [
    'eduzz',
    'alumy',
    'blinket',
    'jobzz',
    'nutror',
    'orbita',
    'safevideo',
    'telescope',
    'next'
];
exports.brandsPrimaryColor = {
    eduzz: '#0D2772',
    alumy: '#6200EE',
    blinket: '#D81B60',
    jobzz: '#01579B',
    nutror: '#00A526',
    orbita: '#0D47A1',
    safevideo: '#E39837',
    telescope: '#8E24AA',
    next: '#6063AB'
};
